<template>
    <div
        class="fixed bottom-2 right-2 flex items-start justify-end"
        :style="{ zIndex: 999 }"
    >
        <div class="w-full max-w-sm">
            <transition name="fade">
                <div v-if="show">
                    <div
                        class="flex w-full max-w-sm mx-auto mt-4 overflow-hidden bg-white dark:bg-slate-800 rounded-lg shadow dark:shadow-slate-900/50 p-4 border border-slate-200 dark:border-slate-700 justify-start items-start gap-3"
                    >
                        <div
                            class="flex items-center justify-center text-green-500"
                        >
                            <Icon icon="loader" svgClass="w-5 h-5" />
                        </div>
                        <div
                            class="flex-col justify-start items-start flex text-sm grow"
                        >
                            <span class="text-green-800 font-medium">
                                Updating your account data...
                            </span>
                            <p class="text-slate-500 dark:text-slate-400 font-normal">
                                Data sync in progress
                            </p>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>
<script setup>
import { ref, onMounted, onBeforeUnmount, watch, onUnmounted } from 'vue';
import { notify } from 'notiwind';
import Icon from '@/components/ui/icon/icon.vue';


let timerInterval;

const emit = defineEmits(['complete']);
const hasNotiwind = ref(false);
const teaserOpen = ref(false);
const show = ref(false);
const modalOpen = ref(false);
let openHandler;
let closeHandler;
let observer;

const dataSync = () => {
    axios
        .get('/api/data/sync')
        .then((response) => {
            if (response.data.in_progress && !hasNotiwind.value) {
                show.value = true;
                startTimer();
                hasNotiwind.value = true;
                emit('complete', response.data);
            }
            if (!response.data.in_progress) {
                show.value = false;
                hasNotiwind.value = false;
                stopTimer();
            }
        })
        .catch((e) => {
            show.value = false;
            hasNotiwind.value = false;
            notify(
                {
                    group: 'error',
                    title: 'Error',
                    message: 'There was a problem with your account data sync',
                },
                5000
            );
        });
};

const startTimer = () => {
    timerInterval = setInterval(() => {
        dataSync();
    }, 2000);
};

const stopTimer = () => {
    clearInterval(timerInterval);
};

onMounted(() => {
    dataSync();
    openHandler = () => {
        teaserOpen.value = true;
    };
    closeHandler = () => {
        teaserOpen.value = false;
    };
    window.addEventListener('tour-teaser-open', openHandler);
    window.addEventListener('tour-teaser-close', closeHandler);

    const checkModals = () => {
        const modals = document.querySelectorAll(
            '.modal, .fixed.inset-0[role="dialog"]'
        );
        modalOpen.value = modals.length > 0;
    };

    observer = new MutationObserver(() => {
        checkModals();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class'],
    });

    checkModals();
});

onBeforeUnmount(() => {
    stopTimer();

    window.removeEventListener('tour-teaser-open', openHandler);
    window.removeEventListener('tour-teaser-close', closeHandler);
    observer.disconnect();
});

watch(show, (isShowing) => {
    try {
        const eventName = isShowing ? 'data-sync-show' : 'data-sync-hide';
        window.dispatchEvent(new CustomEvent(eventName));
    } catch (_) {}
});
</script>
